<template>
  <v-responsive class="border rounded">
    <v-app>
      <TopNavigation v-if="authStore.showNav" ref="topNavigation" />
      <v-main>
        <router-view @snack="handleSnack"></router-view>
      </v-main>
      <SnackWidget v-model:show="snackShow" @timeout="snackShow = false">{{
        snackText
      }}</SnackWidget>
    </v-app>
  </v-responsive>
</template>

<script setup lang="ts">
import TopNavigation from '@/components/ui/navigation/TopNavigation.vue';
import { RouterView } from 'vue-router';
import { ref } from 'vue';
import { useAuthStore } from '@/stores';
import SnackWidget from './components/ui/SnackWidget.vue';
import { SNACKSTATUS } from './stores/util';

const topNavigation = ref(TopNavigation);

const authStore = useAuthStore();
const snackText = ref<string>('');
const snackShow = ref<boolean>(false);

const handleSnack = async (objType: string, snackType: SNACKSTATUS, err: string = '') => {
  const additionalText = err && err != '' ? `: ${err}` : '';
  if (snackType == 'success:create') {
    snackText.value = `${objType} created successfully!`;
    snackShow.value = true;
  } else if (snackType == 'success:update') {
    snackText.value = `${objType} updated successfully!`;
    snackShow.value = true;
  } else if (snackType == 'success:delete') {
    snackText.value = `${objType} removed successfully!`;
    snackShow.value = true;
  } else if (snackType == 'error') {
    snackText.value = `Error updating ${objType}${additionalText}`;
    snackShow.value = true;
  }
};
</script>
